function normalizeItem(item) {
  if (!item) {
    return null;
  }
  const data = { ...item };
  if (data.read === undefined) {
    data.read = Boolean(data.readAt);
  }
  return data;
}

function sortItems(items) {
  return [...items].sort((a, b) => {
    const aDate = new Date(a.createdAt || a.date || 0).getTime();
    const bDate = new Date(b.createdAt || b.date || 0).getTime();
    return bDate - aDate;
  });
}

export default {
  'Notifications.SET_ITEMS': function setItems(state, items) {
    const normalized = items
      .map(normalizeItem)
      .filter(Boolean);
    state.items = sortItems(normalized);
  },
  'Notifications.SET_UNREAD_COUNT': function setUnreadCount(state, value) {
    state.unreadCount = value;
  },
  'Notifications.SET_LOADING': function setLoading(state, value) {
    state.isLoading = value;
  },
  'Notifications.MARK_ALL_READ': function markAllRead(state) {
    const now = new Date().toISOString();
    state.items = state.items.map(item => ({
      ...item,
      read: true,
      readAt: item.readAt || now,
    }));
    state.unreadCount = 0;
  },
  'Notifications.MARK_READ': function markRead(state, id) {
    const now = new Date().toISOString();
    state.items = state.items.map(item => (
      item.id === id ? { ...item, read: true, readAt: item.readAt || now } : item
    ));
    state.unreadCount = Math.max(state.unreadCount - 1, 0);
  },
  'Notifications.PREPEND_ITEM': function prependItem(state, item) {
    const normalized = normalizeItem(item);
    if (!normalized) {
      return;
    }
    state.items = sortItems([normalized, ...state.items]);
    if (!normalized.read) {
      state.unreadCount += 1;
    }
  },
};
